import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';

export default function BrandCTA() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';

  return (
    <section className="w-full bg-[#1A1A1A] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-8">
        {/* Brand mark */}
        <div className="flex items-center gap-0.5">
          <span className="font-sans text-lg font-bold text-[#8A8A8A]">Rx</span>
          <span className="font-sans text-lg font-bold text-[#7B1113]">+.</span>
          <span className="font-sans text-xs font-bold tracking-[0.18em] text-[#8A8A8A] uppercase">K SEOUL</span>
        </div>

        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-[1.15]">
          {t('brandStory.cta.heading')}
        </h2>

        <p className="text-sm text-white/40 font-light leading-[1.8] max-w-lg">
          {t('brandStory.cta.body')}
        </p>

        <div className="flex items-center gap-3 flex-wrap justify-center">
          <Link
            to={prefix + '/products'}
            className="w-full sm:w-auto px-6 py-3.5 bg-[#7B1113] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer text-center"
          >
            {t('common.shopNow')} →
          </Link>
          <Link
            to={prefix + '/stores'}
            className="w-full sm:w-auto px-6 py-3.5 border border-white/30 text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-white/10 transition-colors cursor-pointer text-center"
          >
            {t('common.whereToBuy')} →
          </Link>
          <a
            href="https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/40f179cb-177e-48d0-b0ea-2bb2be981e90_RxKSeoul_Premium_Brochure_EN.pdf"
            download
            rel="nofollow"
            className="w-full sm:w-auto px-6 py-3.5 border border-white/30 text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-white/10 transition-colors cursor-pointer inline-flex items-center justify-center gap-2 text-center"
          >
            <i className="ri-file-download-line"></i>
            {t('brandStory.cta.downloadBrochure')}
          </a>
        </div>
      </div>
    </section>
  );
}